import React, { Component } from 'react';
import { NavMenu } from '../components/NavMenu';
import Sidebar from '../components/Sidebar/Sidebar.tsx';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div className="flex flex-col min-h-screen">
        {/* NavMenu fixed at the top */}
        <div className="fixed w-full top-0 z-50">
          <NavMenu />
        </div>

        {/* Main container */}
        <div className="flex mt-14"> {/* Ajusta mt-14 según la altura de NavMenu */}
          {/* Sidebar */}
          {/* <div className="fixed h-full bg-white border-r w-64 top-14 overflow-y-auto">
            <Sidebar />
          </div> */}

          {/* Main content */}
          <div className="flex-grow p-4">
            <main>
              {this.props.children}
            </main>
          </div>
        </div>
      </div>
    );
  }
}